const WEGIC_REMINDER_TAG = 'wegic_reminder';
const CONTINUE_GENERATION_TAG = 'wegic_continue_generation';

export const REFERENCE_UI_CONFIRMED_SIGNAL = '<wegic-reference-ui-confirmed>true</wegic-reference-ui-confirmed>';

interface ContinueGenerationInputOptions {
  hasReferenceImage?: boolean;
  referenceUiConfirmed?: boolean;
}

export function buildContinueGenerationInputContent(
  continueLabel: string,
  options: ContinueGenerationInputOptions = {},
) {
  const referenceUiSignal = options.referenceUiConfirmed ? `\n${REFERENCE_UI_CONFIRMED_SIGNAL}` : '';
  const referenceImageInstruction = options.hasReferenceImage
    ? '\nUse the attached reference image as the confirmed visual direction. Match its layout, visual style, spacing, color, typography, and overall composition as closely as possible while adapting to the confirmed website requirements.'
    : '';
  const generationReminder = `<${WEGIC_REMINDER_TAG}>\n<${CONTINUE_GENERATION_TAG}></${CONTINUE_GENERATION_TAG}>\nThe user has already finished communicating their requirements, so based on the previous conversation, context, and confirmed needs, generate the website directly without asking further questions, requesting confirmation, or replying with explanations.${referenceImageInstruction}\n</${WEGIC_REMINDER_TAG}>`;

  return `${continueLabel}${referenceUiSignal}\n${generationReminder}`;
}

export function isContinueGenerationInputContent(content: string | null) {
  return content?.includes(`<${CONTINUE_GENERATION_TAG}>`) ?? false;
}

export function stripContinueGenerationReminder(content: string) {
  const reminderStart = content.indexOf(`<${WEGIC_REMINDER_TAG}>`);
  const hasReferenceUiSignal = content.includes(REFERENCE_UI_CONFIRMED_SIGNAL);
  if (reminderStart < 0 && !hasReferenceUiSignal) {
    return content;
  }

  const displayContent = reminderStart >= 0 ? content.slice(0, reminderStart) : content;

  return displayContent.replace(REFERENCE_UI_CONFIRMED_SIGNAL, '').trim();
}
